<div
  class="side-nav"
  [class.link-form]="false"
  [class.private]="contactForm?.controls.ContactTypeId.value === ContactHelper.CONTACT_TYPE_PRIVATE"
  [class.trade]="contactForm?.controls.ContactTypeId.value === ContactHelper.CONTACT_TYPE_TRADE"
  [class.planer]="contactForm?.controls.ContactTypeId.value === ContactHelper.CONTACT_TYPE_PLANER"
  >
  <form onsubmit="return false" [formGroup]="contactForm" class="contact-form" #formEl>

    <div class="main-title" fiTranslation="REQUEST_DETAIL_HEADLINE_CONTACT"></div>

    @if (showErrors && !leadCreationFailureError && !leadCreationFailureRelationshipManagementError) {
      @if (contactExistMessage) {
        <fi-alert class="alert-danger-cont" tone="critical">
          <span fiTranslation="ERROR_LINK_LEAD_NEW_CONTACT"></span>
        </fi-alert>
      }
      @if (!contactExistMessage && hasFilledInvalidInputs) {
        <fi-alert class="alert-danger-cont" tone="critical">
          <span fiTranslation="FORM_INVALID_FIELDS"></span>
        </fi-alert>
      }
      @if (!contactExistMessage && hasEmptyRequiredInputs) {
        <fi-alert class="alert-danger-cont" tone="critical">
          <span fiTranslation="FORM_COMPLETE_MANDATORY_FIELDS"></span>
        </fi-alert>
      }
    }

    @if (showErrors && leadCreationFailureError) {
      <fi-alert class="alert-danger-cont" tone="critical">
        <span fiTranslation="LEAD_ERRORMSG_CREATE"></span>
      </fi-alert>
    }

    @if (showErrors && leadCreationFailureRelationshipManagementError) {
      <fi-alert class="alert-danger-cont" tone="critical">
        <span fiTranslation="LEAD_ERRORMSG_CREATE_RELATIONSHIP_MANAGEMENT"></span>
      </fi-alert>
    }

    @if (showMaxLengthErrors) {
      <fi-alert class="alert-danger-cont" tone="critical">
        <span fiTranslation="GENERAL_ERROR_FIELD_TO_LONG"></span>
      </fi-alert>
    }

    @if (showUpdateContactMessage) {
      <fi-alert class="alert-danger-cont" tone="critical">
        <span fiTranslation="CONTACT_ERRORMSG_HEADLINE_UPDATE_CONTACT"></span>
      </fi-alert>
    }

    <div #inputs class="input-row has-many-children ContactTypeId Salutation">
      <fi-input
        type="SELECT"
        labelKey="%REQUEST_CREATE_CONTACT_TYPE%*"
        [replaceKeys]="true"
        [options]="tabs"
        (onChange)="onContactTypeChange($event)"
        [selectedOptionsOrValues]="contactForm?.controls.ContactTypeId.value"
      ></fi-input>

      <fi-input
        type="SELECT"
        [replaceKeys]="true"
        labelKey="%REQUEST_CREATE_CONTACT_NAME_SALUTATION%*"
        errorKey="%REQUEST_CREATE_CONTACT_SALUTATIN_ERROR_TEXT%"
        [options]="resourceSalutation"
        namePropertyPath="Description"
        (onChange)="contactForm?.controls.Salutation.setValue($event)"
        [selectedOptionsOrValues]="contactForm?.controls.Salutation.value"
        [hasError]="isInvalidForm('contactForm','Salutation')"
      ></fi-input>
    </div>





    @if (notPrivateContactType.includes(contactForm?.controls.ContactTypeId.value)) {
      <div #inputs class="input-row Title">
        <fi-input
          labelKey="REQUEST_CREATE_CONTACT_NAME_TITLE"
          controlName="Title"
          maxLength="64"
          [form]="contactForm"
          (focusin)="checkIfUpdateContent()"
          (focusout)="removeIfUpdateContent()"
          >
        </fi-input>
      </div>
    }

    <div #inputs class="input-row FirstName">
      <fi-input
        [replaceKeys]="true"
        labelKey="%REQUEST_CREATE_CONTACT_HEADLINE_NAME%*"
        [errorKey]="!contactForm?.controls?.FirstName?.value ? '%REQUEST_CREATE_CONTACT_FIRST_NAME_ERROR_TEXT%' : '%FORM_INVALID_FIELDS%'"
        controlName="FirstName"
        maxLength="64"
        [form]="contactForm"
        (focusin)="checkIfUpdateContent()"
        (focusout)="removeIfUpdateContent()"
        [hasError]="isInvalidForm('contactForm','FirstName')"
        >

      </fi-input>
    </div>

    <div #inputs class="input-row LastName">
      <fi-input
        [replaceKeys]="true"
        labelKey="%REQUEST_CREATE_CONTACT_HEADLINE_LAST_NAME%*"
        [errorKey]="!contactForm?.controls?.LastName?.value ? '%REQUEST_CREATE_CONTACT_LAST_NAME_ERROR_TEXT%' : '%FORM_INVALID_FIELDS%'"
        controlName="LastName"
        maxLength="64"
        [form]="contactForm"
        (focusin)="checkIfUpdateContent()"
        (focusout)="removeIfUpdateContent()"
        [hasError]="isInvalidForm('contactForm','LastName')"
        >

      </fi-input>
    </div>


    @if (notPrivateContactType.includes(contactForm?.controls.ContactTypeId.value)) {
      <div #inputs class="input-row Company">
        <fi-input maxLength="128"
          controlName="Company"
          type="SUGGEST"
          labelKey="REQUEST_CREATE_CONTACT_HEADLINE_FIRM"
          namePropertyPath="Name"
          [valuePropertyPath]="getCompanyName"
          [form]="contactForm"
          [enableSearch]="true"
          [selectedOptionsOrValues]="selectedCompany"
          (focusin)="checkIfUpdateContent()"
          (focusout)="removeIfUpdateContent()"
          [hasError]="isInvalidForm('contactForm','Company')"
          [options]="contactCompanies"
          (onSearch)="onCompanySearch($event)"
          (onChange)="onCompanySelect($event)"
          [readOnly]="additionalContact"
          [hintKey]="isUpdate && !additionalContact ? 'REQUEST_CREATE_CONTACT_COMPANY_HELPER_TEXT' : null"
          errorKey="FORM_INVALID_FIELDS"
          >
        </fi-input>
      </div>
    }

    @if (notPrivateContactType.includes(contactForm?.controls.ContactTypeId.value)) {
      <div #inputs class="input-row JobTitle">
        <fi-input
          labelKey="REQUEST_CREATE_CONTACT_JOB_TITLE"
          controlName="JobTitle"
          maxLength="128"
          [form]="contactForm"
          [hasError]="isInvalidForm('contactForm','JobTitle')"
          (focusin)="checkIfUpdateContent()"
          (focusout)="removeIfUpdateContent()"
          errorKey="FORM_INVALID_FIELDS"
          >
        </fi-input>
      </div>
    }


    @if (!isNewLeadForm && !additionalContact && compendiumVisible) {
      <div #inputs class="input-row checkbox-block">
        <fi-checkbox
          (checkedChange)="consentChanges()"
          id="accessCompendium"
          [disabled]="!compendiumActionEnabled"
          class="consent-checkbox"
          [class.disabled]="!compendiumActionEnabled"
          [ngModelOptions]="{standalone: true}"
          [(ngModel)]="accessCompendium"
          >
          <div class="checkbox-label" fiTranslation="REQUEST_EDIT_CONTACT_CHECKBOX_COMPENDIUM_ACCES"></div>
          <div class="checkbox-description" fiTranslation="REQUEST_EDIT_CONTACT_CHECKBOX_COMPENDIUM_ACCES_DESCRIPTION"></div>
        </fi-checkbox>
      </div>
    }


    <div #inputs class="input-row has-circle Email">
      <fi-input
        type="EMAIL"
        maxLength="128"
        [labelKey]="'%FORM_HEADLINE_E-MAIL%' + getEmailOrPhoneRequiredStar"
        [replaceKeys]="true"
        controlName="Email"
        [errorKey]="contactForm?.controls.Email.value ? '%CONTACT_ERRORMSG_EMAIL_NOT_VALID%' : '%REQUEST_CREATE_CONTACT_EMAIL_ERROR_TEXT%'"
        [hasError]="needsAtLeastOneEmailOrPhone || isInvalidForm('contactForm','Email')"
        [form]="contactForm"
        (onChange)="checkExistingEmail(); checkIfEmailOrPhoneNeedsToBeFilled(true);"
        (focusin)="checkIfUpdateContent(1)"
        (focusout)="removeIfUpdateContent(1)"
        >

      </fi-input>

      <div class="circle-container" (click)="contactForm?.controls.ContactMethodId.setValue(1); actionHelper.notifyAboutEdit();">
        <div class="circle">
          @if (contactForm?.controls.ContactMethodId.value === 1) {
            <div class="inner-circle"></div>
          }
        </div>
        <div class="preference" fiTranslation="REQUEST_DETAIL_HEADLINE_PREFERENCE"></div>
      </div>
    </div>

    @if (emails) {
      <div #inputs class="input-row AdditionalEmail">
        <fi-input
          type="EMAIL"
          maxLength="128"
          labelKey="REQUEST_CREATE_CONTACT_EXTRA_EMAIL"
          controlName="AdditionalEmail"
          (onChange)="checkIfEmailOrPhoneNeedsToBeFilled(true);"
          [hasError]="isInvalidForm('contactForm','AdditionalEmail')"
          errorKey="CONTACT_ERRORMSG_EMAIL_NOT_VALID"
          [form]="contactForm"
          (focusin)="checkIfUpdateContent()"
          (focusout)="removeIfUpdateContent(); removeUpdateExternalEmail()"
          >
        </fi-input>
      </div>
    }

    <button type="button" class="add-email_cont" (click)="addEmail()">
      <span class="text" fiTranslation="FORM_HEADLINE_ADDITIONAL_E-MAIL"></span>
      <mat-icon>
        {{ emails ? 'remove' : 'add' }}
      </mat-icon>
    </button>

    <div #inputs class="input-row has-circle Phone">
      <div class="mobile-pair">
        <fi-input
          type="SELECT"
          [labelKey]="'%REQUEST_CREATE_CONTACT_HEADLINE_AREA_CODE%' + getEmailOrPhoneRequiredStar"
          errorKey="%REQUEST_CREATE_CONTACT_PHONE_NUMBER_ERROR_TEXT%"
          [replaceKeys]="true"
          [enableSearch]="true"
          (onChange)="setPhonePrefix($event)"
          [options]="numberPrefixes"
          [selectedOptionsOrValues]="contactForm?.controls.PhonePrefix.value"
          namePropertyPath="name"
          valuePropertyPath="code"
          [hasError]="needsAtLeastOneEmailOrPhone || isInvalidForm('contactForm','PhonePrefix')"
          >
        </fi-input>

        <fi-input
          maxLength="32"
          controlName="Phone"
          type="PHONE"
          [labelKey]="'%REQUEST_CREATE_CONTACT_HEADLINE_WORK%' + getEmailOrPhoneRequiredStar"
          [replaceKeys]="true"
          [hasError]="needsAtLeastOneEmailOrPhone || isInvalidForm('contactForm','Phone')"
          [form]="contactForm"
          (onChange)="checkIfEmailOrPhoneNeedsToBeFilled(true);"
          (focusin)="checkIfUpdateContent(2)"
          (focusout)="removeIfUpdateContent(2)"
          >

        </fi-input>
      </div>

      <div class="circle-container" (click)="contactForm?.controls.ContactMethodId.setValue(2); actionHelper.notifyAboutEdit();">
        <div class="circle">
          @if (contactForm?.controls.ContactMethodId.value === 2) {
            <div class="inner-circle"></div>
          }
        </div>
        <div class="preference" fiTranslation="REQUEST_DETAIL_HEADLINE_PREFERENCE"></div>
      </div>
    </div>

    <div #inputs class="input-row has-circle Mobile">
      <div class="mobile-pair">
        <fi-input
          type="SELECT"
          labelKey="REQUEST_CREATE_CONTACT_HEADLINE_AREA_CODE"
          [enableSearch]="true"
          (onChange)="setMobilePhonePrefix($event)"
          [options]="numberPrefixes"
          [selectedOptionsOrValues]="contactForm?.controls.MobilePrefix.value"
          namePropertyPath="name"
          valuePropertyPath="code"
          [hasError]="isInvalidForm('contactForm','MobilePrefix')"
          >
        </fi-input>

        <fi-input
          maxLength="32"
          controlName="Mobile"
          type="PHONE"
          labelKey="FORM_HEADLINE_MOBILE"
          (onChange)="checkIfEmailOrPhoneNeedsToBeFilled(true);"
          [hasError]="isInvalidForm('contactForm','Mobile')"
          [form]="contactForm"
          (focusin)="checkIfUpdateContent(3)"
          (focusout)="removeIfUpdateContent(3)"
          >

        </fi-input>
      </div>

      <div class="circle-container" (click)="contactForm?.controls.ContactMethodId.setValue(3); actionHelper.notifyAboutEdit();">
        <div class="circle">
          @if (contactForm?.controls.ContactMethodId.value === 3) {
            <div class="inner-circle"></div>
          }
        </div>
        <div class="preference" fiTranslation="REQUEST_DETAIL_HEADLINE_PREFERENCE"></div>
      </div>

    </div>


    @if (mobileNumbers) {
      <div #inputs class="input-row PhoneOther">
        <div class="mobile-pair">
          <fi-input
            type="SELECT"
            labelKey="REQUEST_CREATE_CONTACT_HEADLINE_AREA_CODE"
            [enableSearch]="true"
            (onChange)="contactForm?.controls.PhoneOtherPrefix.setValue($event)"
            [options]="numberPrefixes"
            [selectedOptionsOrValues]="contactForm?.controls.PhoneOtherPrefix.value"
            namePropertyPath="name"
            valuePropertyPath="code"
            [hasError]="isInvalidForm('contactForm','PhoneOtherPrefix')"
            >
          </fi-input>
          <fi-input
            maxLength="32"
            controlName="PhoneOther"
            labelKey="REQUEST_CREATE_CONTACT_EXTRA_PHONE"
            type="PHONE"
            (onChange)="checkIfEmailOrPhoneNeedsToBeFilled(true);"
            [hasError]="isInvalidForm('contactForm','PhoneOther')"
            [form]="contactForm"
            (focusin)="checkIfUpdateContent(3)"
            (focusout)="removeIfUpdateContent(3)"
            >
          </fi-input>
        </div>
      </div>
    }




    <button type="button" class="add-phone_cont" (click)="addMobileNumber()">
      <span class="text" fiTranslation="REQUEST_DETAIL_NOTE_PHONE"></span>
      <mat-icon>
        {{ mobileNumbers ? 'remove' : 'add' }}
      </mat-icon>
    </button>

    <ng-template #privacyCheckboxes>
      <div #inputs class="privacy privacyContact" [class.top-margin]="!isNewLeadForm">
        <fi-checkbox
          (checkedChange)="consentChanges()"
          [disabled]="true"
          id="privacyTextAgreementText"
          class="consent-checkbox disabled"
          [class.invalid]="showErrors && !privacy.contact"
          [ngModelOptions]="{standalone: true}"
          [(ngModel)]="privacy.contact"
          >
          <div class="checkbox-label">
            <span fiTranslation="REQUEST_DETAIL_HEADLINE_CONSENT_PRIVACY"></span>*
          </div>
          <div class="checkbox-description" fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_PRIVACY_AGREE_TO_STORE_DATA_2"></div>
        </fi-checkbox>

        <fi-checkbox
          (checkedChange)="consentChanges()"
          id="consentMarketing"
          class="consent-checkbox"
          [ngModelOptions]="{standalone: true}"
          [(ngModel)]="consentMarketing"
          >
          <div class="checkbox-label" fiTranslation="REQUEST_DETAIL_HEADLINE_CONSENT_MARKETING"></div>
          <div class="checkbox-description" fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_MARKETING_CONSENT_AGREE"></div>
        </fi-checkbox>

        <fi-checkbox
          (checkedChange)="consentChanges()"
          id="consentThirdParties"
          class="consent-checkbox"
          [ngModelOptions]="{standalone: true}"
          [(ngModel)]="consentThirdParties"
          >
          <div class="checkbox-label" fiTranslation="REQUEST_DETAIL_HEADLINE_CONSENT_MARKETING_THIRD_PARTIES"></div>
          <div class="checkbox-description" fiTranslation="REQUEST_CREATE_CONTACT_CHECKBOX_MARKETING_CONSENT_THIRD_PARTIES_AGREE"></div>
        </fi-checkbox>
      </div>
    </ng-template>

    @if (isNewLeadForm) {
      <ng-container *ngTemplateOutlet="privacyCheckboxes"></ng-container>
    }

    <div>
      <button type="button" class="more-details-btn" [class.open]="showDetails" (click)="toggleShowMore()">
        <span fiTranslation="REQUEST_CREATE_CONTACT_ACCORDION_MORE_DETAILS"></span>
        <img [class.open]="showDetails" class="arrow" alt="arrow" src="/assets/icons/arrow-up.svg">

      </button>
    </div>

    @if (showDetails) {
      <div #inputs class="input-row LanguageCode">
        <fi-input
          type="SELECT"
          [replaceKeys]="true"
          [enableSearch]="true"
          labelKey="%FORM_HEADLINE_LANGUAGE%*"
          [options]="resourceLanguages"
          namePropertyPath="Name"
          valuePropertyPath="Code"
          (onChange)="setLanguageCode($event)"
          [selectedOptionsOrValues]="contactForm?.controls.LanguageCode.value"
          [hasError]="isInvalidForm('contactForm','LanguageCode')"
        ></fi-input>
      </div>
      <div #inputs class="input-row Address">
        <fi-input maxLength="128"
          controlName="Address"
          [replaceKeys]="true"
          [labelKey]="'%REQUEST_DETAIL_HEADLINE_ADDRESS%' + getContactAddressRequiredStar"
          [errorKey]="contactForm?.controls.Address.value ? '%FORM_INVALID_FIELDS%' : '%REQUEST_CREATE_CONTACT_ADDRESS_ERROR_TEXT%'"
          [form]="contactForm"
          [hasError]="isInvalidForm('contactForm','Address')"
          (focusin)="checkIfUpdateContent()"
          (focusout)="removeIfUpdateContent()"
          >
        </fi-input>
      </div>
      <div #inputs class="input-row AddressExt">
        <fi-input maxLength="128"
          controlName="AddressExt"
          labelKey="REQUEST_CREATE_CONTACT_HEADLINE_ADDRESS_EXTRA"
          [form]="contactForm"
          (focusin)="checkIfUpdateContent()"
          (focusout)="removeIfUpdateContent()"
          [hasError]="isInvalidForm('contactForm','AddressExt')"
          errorKey="FORM_INVALID_FIELDS"
          >
        </fi-input>
      </div>
      <div #inputs class="input-row has-many-children ZipCode City">
        <fi-input maxLength="8"
          controlName="ZipCode"
          [replaceKeys]="true"
          [labelKey]="'%REQUEST_CREATE_CONTACT_HEADLINE_ZIPCODE%' + getContactAddressRequiredStar"
          [errorKey]="contactForm?.controls.ZipCode.value ? '%FORM_INVALID_FIELDS%' : '%REQUEST_CREATE_CONTACT_ZIP_CODE_ERROR_TEXT%'"
          [hasError]="isInvalidForm('contactForm','ZipCode')"
          [form]="contactForm"
          (focusin)="checkIfUpdateContent()"
          (focusout)="removeIfUpdateContent()"
          >
        </fi-input>
        <fi-input maxLength="64"
          controlName="City"
          [replaceKeys]="true"
          [labelKey]="'%REQUEST_CREATE_CONTACT_HEADLINE_CITY%' + getContactAddressRequiredStar"
          [errorKey]="contactForm?.controls.City.value ? '%FORM_INVALID_FIELDS%' : '%REQUEST_CREATE_CONTACT_LOCALITY_ERROR_TEXT%'"
          [hasError]="isInvalidForm('contactForm','City')"
          [form]="contactForm"
          (focusin)="checkIfUpdateContent()"
          (focusout)="removeIfUpdateContent()"
          >
        </fi-input>
      </div>
      <div #inputs class="input-row has-many-children CountryCode ProvinceCode">
        <fi-input
          type="SELECT"
          [replaceKeys]="true"
          [enableSearch]="true"
          [labelKey]="'%REQUEST_CREATE_CONTACT_HEADLINE_COUNTRY%' + getContactAddressRequiredStar"
          errorKey="%REQUEST_CREATE_CONTACT_COUNTRY_ERROR_TEXT%"
          [selectedOptionsOrValues]="contactForm?.controls.CountryCode.value"
          [options]="resourceCountries"
          namePropertyPath="Name"
          valuePropertyPath="IsoCode"
          (onChange)="setCountyCode($event, true)"
          [hasError]="isInvalidForm('contactForm','CountryCode')"
          >
        </fi-input>
        @if (provinceCountryCodes?.includes(contactForm?.controls.CountryCode.value)) {
          <fi-input type="SELECT"
            labelKey="REQUEST_CREATE_CONTACT_HEADLINE_PROVINCE"
            [enableSearch]="true"
            [options]="resourceProvinces"
            [namePropertyPath]="'Text'"
            [valuePropertyPath]="'Code'"
            [selectedOptionsOrValues]="contactForm?.controls.ProvinceCode.value"
            (onChange)="contactForm?.controls.ProvinceCode.setValue($event)"
            [hasError]="isInvalidForm('contactForm','ProvinceCode')"
            (focusin)="checkIfUpdateContent()"
            (focusout)="removeIfUpdateContent()"
            >
          </fi-input>
        }
      </div>
      @if (contactForm?.controls.TaxNumber) {
        <div #inputs class="input-row TaxNumber">
          <fi-input maxLength="128"
            controlName="TaxNumber"
            labelKey="REQUEST_CREATE_CONTACT_TAX_NUMBER"
            errorKey="FORM_INVALID_FIELDS"
            [form]="contactForm"
            [hasError]="isInvalidForm('contactForm','TaxNumber')"
            (focusin)="checkIfUpdateContent()"
            (focusout)="removeIfUpdateContent()"
            >
          </fi-input>
        </div>
      }
      @if (notPrivateContactType.includes(contactForm?.controls.ContactTypeId.value)) {
        <div #inputs class="input-row has-many-children VatNumber Website">
          <fi-input maxLength="128"
            controlName="VatNumber"
            labelKey="REQUEST_CREATE_CONTACT_HEADLINE_VAT"
            [hasError]="isInvalidForm('contactForm','VatNumber')"
            errorKey="FORM_INVALID_FIELDS"
            [form]="contactForm"
            (focusin)="checkIfUpdateContent()"
            (focusout)="removeIfUpdateContent()"
            >
          </fi-input>
          <fi-input maxLength="512"
            controlName="Website"
            labelKey="REQUEST_CREATE_CONTACT_HEADLINE_WEBSITE"
            [hasError]="isInvalidForm('contactForm','Website')"
            errorKey="FORM_INVALID_FIELDS"
            [form]="contactForm"
            (focusin)="checkIfUpdateContent()"
            (focusout)="removeIfUpdateContent()"
            >
          </fi-input>
        </div>
      }
    }
    @if (!isNewLeadForm) {
      <ng-container *ngTemplateOutlet="privacyCheckboxes"></ng-container>
    }
  </form>
</div>




